const activities = [
    {
        "id": 1,
        "name": "Child Support",
        "photo": "https://iili.io/2VKpV9.md.png"
    },
    {
        "id": 2,
        "name": "Refuge Shelter",
        "photo": "https://iili.io/2Vfzla.md.png"
    },
    {
        "id": 3,
        "name": "Food Charity",
        "photo": "https://iili.io/2VffDB.md.png"
    },
    {
        "id": 4,
        "name": "Host a CLothing swap",
        "photo": "https://iili.io/2Vf3Hx.md.png"
    },
    {
        "id": 5,
        "name": "Host a river clean-up",
        "photo": "https://iili.io/2VfARR.md.png"
    },
    {
        "id": 6,
        "name": "Clean water for children",
        "photo": "https://iili.io/2VfJcb.md.png"
    },
    {
        "id": 7,
        "name": "Good education",
        "photo": "https://iili.io/2VfCV1.md.png"
    },
    {
        "id": 8,
        "name": "New books for children",
        "photo": "https://iili.io/2VfIUJ.md.png"
    },
    {
        "id": 9,
        "name": "Host a study group",
        "photo": "https://iili.io/2Vf5DN.md.png"
    },
    {
        "id": 10,
        "name": "Build bird house for your neighbors",
        "photo": "https://iili.io/2VKyPe.md.png"
    },
    {
        "id": 11,
        "name": "Organize books at the library",
        "photo": "https://iili.io/2VfniF.md.png"
    },
    {
        "id": 12,
        "name": "Give a seminar on driving safety",
        "photo": "https://iili.io/2VfdSj.md.png"
    },
    {
        "id": 13,
        "name": "Give free music lessons",
        "photo": "https://iili.io/2VfxKg.md.png"
    },
    {
        "id": 14,
        "name": "Teach people how to register to vote ",
        "photo": "https://iili.io/2Vf1ls.md.png" 
    },
    {
        "id": 15,
        "name": "Clean up your local park",
        "photo": "https://iili.io/2VfFAQ.md.png"
    },
    {
        "id": 16,
        "name": "Give It help to local adults",
        "photo": "https://iili.io/2VfBoP.md.png"
    },
    {
        "id": 17,
        "name": "Faster a shelter animal",
        "photo": "https://iili.io/2VfHKu.md.png"
    },
    {
        "id": 18,
        "name": "Babysit during PTA meetings",
        "photo": "https://iili.io/2VKmo7.md.png"
    },
    {
        "id": 19,
        "name": "Collect stuffed animals",
        "photo": "https://iili.io/2VfaVt.md.png"
    },
    {
        "id": 20,
        "name": "Collect school supplies",
        "photo": "https://iili.io/2VfRNp.md.png"
    },
]
export default activities;